exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-rule-main {\n  box-sizing: border-box;\n  background-color: transparent;\n  padding: 0.2rem;\n}\n.case-rule-main .rule-box {\n  line-height: 0.4rem;\n  font-size: 0.28rem;\n}\n.ar {\n  direction: rtl;\n  unicode-bidi: bidi-override;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/caserule/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/caserule/index.less
// module chunks = 0